let currentUrl = window.location.href;
function isProductPage(){
  return currentUrl.includes("/products/")
}
 
//---------------------------------------------------------------------------------------------
// PRODUCT PAGE SEO - PRODUCT TITLE H1 - PRODUCT DESCRIPTION DESPLEGABLE
//---------------------------------------------------------------------------------------------
if (isProductPage()){ 
  let lastUrl = location.href; 
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      editProdPage();
    }
  }).observe(document, {subtree: true, childList: true});

  let scriptMetacampos = document.getElementById('pangoVariantMeta').textContent;
  let objMetacampos = JSON.parse(scriptMetacampos);
  
  function getSelectedVariantId() {
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    let variant_id = params.variant;
    return Number(variant_id);
  }
  // description
  function getSelectedVariantDescription(currentVariantId){
    let selectedV = objMetacampos.find(v => v.id === currentVariantId);
    let descriptionHtml = atob(selectedV.metacampoDescription);
    return  decodeURIComponent(escape(descriptionHtml));
  }
  // title
  function getSelectedVariantTitle(currentVariantId){
    let selectedV = objMetacampos.find(v => v.id === currentVariantId);
    let title =  selectedV.metacampoTitle;
    return  title;
  }
  function editProdPage(){
    let currentVariantId =  getSelectedVariantId();
    
    let description = getSelectedVariantDescription(currentVariantId)
    // let descriptionElementToEdit = document.querySelector('.cc-accordion-item__content');
    let descriptionElementToEdit = document.querySelector('.pango-description .product-description');
    if (descriptionElementToEdit) {
      descriptionElementToEdit.innerHTML = description;
    } 

    let title = getSelectedVariantTitle(currentVariantId)
    let titleElement = document.querySelector('h1.title');
    titleElement.innerHTML= title;   
  }
  
}

//---------------------------------------------------------------------------------------------
// BLOG POST BLOQUE EXTRA DE COLECCIONES
//---------------------------------------------------------------------------------------------
// Append the gallery inside bloque-extra
const galleryElement = document.querySelector('[data-section-type="gallery"]');
const bloqueExtraCollections = document.getElementById('bloque-extra');

// Actualizar la altura del bloque-extra
function updateParentHeight() {
    bloqueExtraCollections.style.height = `${galleryElement.offsetHeight}px`;
} 
if (galleryElement && bloqueExtraCollections) {
    bloqueExtraCollections.appendChild(galleryElement);
    window.addEventListener('load', updateParentHeight);
    window.addEventListener('resize', updateParentHeight);      
}  

//---------------------------------------------------------------------------------------------
// BLOG POST BLOQUE EXTRA DE AUTOR
//---------------------------------------------------------------------------------------------
 
const bloqueExtraAutor = document.getElementById('bloque-extra-autor');
const sectionAutor = document.getElementById('pango-blog-author');
 
// Actualizar la altura del bloque-extra
function updateParentHeightAutor() {
    bloqueExtraAutor.style.height = `${sectionAutor.offsetHeight}px`;
} 
if (sectionAutor && bloqueExtraAutor) {
    bloqueExtraAutor.appendChild(sectionAutor);
    window.addEventListener('load', updateParentHeightAutor);
    window.addEventListener('resize', updateParentHeightAutor);      
}  